import { transformProducts } from '../product'

function moveDetailElements() {
    if ($('.in-produkty').length) {
        const lastDetails = document.querySelector('.last_details')
        const cartBlock = document.querySelector('.p-to-cart-block')

        if (lastDetails && cartBlock) {
            cartBlock.parentNode.insertBefore(lastDetails, cartBlock)
        }
    }
}

function productRatings() {
    const starList = document.querySelector('.stars.star-list')
    if (!starList) {
        setTimeout(productRatings, 500)
        return
    }

    const firstStar = starList.querySelector('.star, .star-half')
    if (!firstStar) {
        setTimeout(productRatings, 500)
        return
    }

    const title = firstStar.getAttribute('data-original-title')
    if (!title) {
        setTimeout(productRatings, 500)
        return
    }

    const match = title.match(/([\d.]+)\/5/)
    if (match) {
        const ratingValue = match[1]

        const ratingParagraph = document.createElement('p')
        ratingParagraph.textContent = ratingValue
        starList.parentNode.insertBefore(ratingParagraph, starList)
    }

    const starsLabel = document.querySelector('.stars-label')
    if (starsLabel && !document.querySelector('.stars-label + a')) {
        const hrefLink = document.createElement('a')
        hrefLink.href = '#ratingTab_new'
        hrefLink.className = 'dshpp_btn'
        hrefLink.textContent = 'Viac >'
        starsLabel.insertAdjacentElement('afterend', hrefLink)
    }
}

function convertYoutubeUrl(url) {
    const videoId = url.match(
        /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/
    )?.[1]
    if (!videoId) return url
    return `https://youtube.com/embed/${videoId}`
}

function createVideoComponent(heading, description, videoUrl) {
    const embedUrl = convertYoutubeUrl(videoUrl)

    return `
        <div class="module come-in" style="text-align: center;">
            <div class="box_wrapper">
                <div class="box_container container">
                    <div class="box_child2">
                        <h3>${heading}</h3>
                        ${description}
                    </div>
                    <div class="box_video">
                        <iframe 
                            width="100%" 
                            height="100%" 
                            src="${embedUrl}" 
                            allowfullscreen="allowfullscreen">
                        </iframe>
                    </div>
                </div>
            </div>
        </div>
    `
}

function addVideoBlockToDescription() {
    const basicDescription = document.querySelector('.basic-description')
    if (!basicDescription) return

    const children = Array.from(basicDescription.children)
    let isCollecting = false
    let videoContent = {
        elements: [],
        startIndex: -1,
        endIndex: -1,
    }

    // Find content between #video tags
    children.forEach((child, index) => {
        if (child.textContent.trim() === '#video') {
            if (!isCollecting) {
                isCollecting = true
                videoContent.startIndex = index
            } else {
                isCollecting = false
                videoContent.endIndex = index
            }
        } else if (isCollecting) {
            videoContent.elements.push(child)
        }
    })

    if (videoContent.elements.length > 0 && videoContent.startIndex !== -1) {
        let heading = ''
        let description = ''
        let videoUrl = ''

        // Find the first heading element (h1, h2, h3, etc.)
        const headingElement = videoContent.elements.find(
            (element) => element.tagName && element.tagName.match(/^H[1-6]$/i)
        )

        if (headingElement) {
            heading = headingElement.innerHTML
        }

        // Find YouTube URL from any paragraph
        const youtubeParagraph = videoContent.elements.find(
            (element) => element.tagName === 'P' && element.textContent.includes('youtube.com')
        )

        if (youtubeParagraph) {
            videoUrl = youtubeParagraph.textContent.trim()
        }

        // Collect all other content for description
        const descriptionElements = videoContent.elements.filter(
            (element) => element !== headingElement && element !== youtubeParagraph
        )

        if (descriptionElements.length > 0) {
            description = descriptionElements.map((element) => element.outerHTML).join('')
        }

        // Create video component
        const videoComponent = createVideoComponent(heading, description, videoUrl)

        // Remove original content between #video tags
        for (let i = videoContent.endIndex; i >= videoContent.startIndex; i--) {
            basicDescription.children[i].remove()
        }

        $(videoComponent).insertAfter('.basic-description .box_wrapper:last')
    }
}

export function initDetail() {
    moveDetailElements()
    productRatings()
    addVideoBlockToDescription()
}
